import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader } from '@monksflow/monks-ui';
import { EmptyStateTitle } from '@/shared/ui';
import { useTranslation } from 'react-i18next';

interface BriefsErrorStateProps {
  /** Fires when the user clicks the retry button. Wired by the parent to `query.refetch()`. */
  onRetry: () => void;
}

/**
 * Error state for the briefs list view.
 *
 * Pure presentational. Rendered by `BriefsTable` when the briefs query
 * errors and there is no previous data to fall back on.
 *
 * `role="alert"` makes screen readers announce the failure immediately.
 */
export function BriefsErrorState(props: BriefsErrorStateProps) {
  const { t } = useTranslation('projects');

  return (
    <Empty role="alert" data-testid="briefs-error-state" className="flex-1">
      <EmptyHeader>
        <EmptyStateTitle>{t('projectDetail.briefsErrorState.couldnTLoadBriefs')}</EmptyStateTitle>
        <EmptyDescription>
          {t('projectDetail.briefsErrorState.somethingWentWrongTryAgain')}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" size="default" onClick={props.onRetry}>
          {t('projectDetail.briefsErrorState.tryAgain')}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
